// extracted by mini-css-extract-plugin
export default {"title":"jaa-z","warning":"kaa-z","sizeOptionsLegendText":"laa-z"};